import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = () => {
  return (
    <aside className="app-sidebar">
      <nav className="sidebar-nav">
        <NavLink to="/dashboard" className={({isActive}) => isActive ? 'nav-item active' : 'nav-item'}>Dashboard</NavLink>
        <NavLink to="/users" className={({isActive}) => isActive ? 'nav-item active' : 'nav-item'}>User Management</NavLink>
      </nav>
    </aside>
  );
};

export default Sidebar;
